//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SpriteIcon from '../elements/SpriteIcon';

export default {
    components: {
        SpriteIcon,
    },
    props: {
        lang: {
            type: String,
            required: true,
        }
    },
    computed: {
        computedCountry: function() {
            return this.lang === 'nl' ? 'België' : 'Belgique';
        }
    },
    data() {
        return {
            disableDuringAction: false,
            acceptedTermsOfSales: false,
            promocode: '',
            promocodeValid: null,
            pack: {
                subscription_content: [],
                content_each_month: [],
                machine_image: false,
            },
            user: {
                deliveryStreet: '',
                deliveryStreetNumber: '',
                deliveryBox: '',
                deliveryZip: '',
                deliveryCity: '',
                deliveryCountry: '',
                sameAddress: false,
                billingStreet: '',
                billingStreetNumber: '',
                billingBox: '',
                billingZipCode: '',
                billingCity: '',
                billingCountryCode: '',
            },
        }
    },
    watch: {
        promocode() {
            if ( this.promocodeValid !== true ) {
                this.promocodeValid = null;
            }
        }
    },
    methods: {
        handlePrevious(step = -1)
        {
            window.dataLayer?.push( { 'event': 'step3prev' } );

            this.$nextTick( () => this.$emit('previous', step ) );
        },

        handlePromocode()
        {
            this.disableDuringAction = true;

            this.$app.get('axios').post('/api/funnel/promocode?lang=' + this.lang, {
                promocode: this.promocode,
            } ).then( response => {
                this.promocodeValid = response.data.valid;

                this.$emit('refresh');

                this.disableDuringAction = false;
            } ).catch( () => {
                this.disableDuringAction = false;
            } );
        },

        handleSubmit()
        {
            window.dataLayer?.push( { 'event': 'step3next' } );

            this.$nextTick( () => this.$emit('submit') )
        },
    },

    created()
    {
        this.$app.get('axios').get('/api/funnel/user?lang=' + this.lang ).then( response => {
            if ( response.data === false || response.data.billingZipCode === null ) {
                this.handlePrevious( 0 );
            }

            this.user = response.data;

            this.$app.get('axios').get('/api/funnel/pack?lang=' + this.lang ).then( response => {
                this.pack = response.data;

                this.$app.get('axios').get('/api/funnel/promocode').then( response => {
                    if ( response.data.promocode ) {
                        this.promocode = response.data.promocode;
                        this.promocodeValid = true;
                    }
                } );
            } );
        } );
    },

    mounted() {
        window.dataLayer?.push( { 'event': 'step3in' } );
    }
}
